import React from 'react';
import PropTypes from 'prop-types';

import { App } from '@meronex/app';

import { ActionBtn, CloseBtn, toast } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

import TeamForm from './TeamForm';
import { teamsMng } from '../api/teamsMng';

const useStyles = makeStyles((theme) => ({
  container: {},
}));

function EditTeamDialog(props) {
  const classes = useStyles();
  const theme = useTheme();

  const { open, onClose, onEdit, team } = props;

  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = React.useState({ isValid: true });

  React.useEffect(() => {
    setFormData({ ...team });
  }, [team]);

  const _onClose = () => {
    onClose();
  };

  const editTeam = async () => {
    console.log('on edit');
    console.log(team);

    setLoading(true);

    const _updatedTeam = Object.assign(team, formData);
    delete _updatedTeam.isValid;

    try {
      await teamsMng.updateTeam(_updatedTeam);
      onEdit();
      onClose();
      toast.success('Team updated', {
        autoClose: 900,
      });
    } catch (e) {
      toast.error('Ops, something went wrong');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  if (!team || !open) {
    return null;
  }
  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose}>
      <DialogTitle>
        Edit Team
        <CloseBtn onClick={_onClose} />
      </DialogTitle>
      <DialogContent>
        <TeamForm
          validateOnInit={true}
          onChange={(values) => {
            console.log(values);
            setFormData({ ...Object.assign(formData, values) });
          }}
          values={formData}
        />
        <div
          style={{
            marginBottom: '20px',
            marginTop: '20px',
            textAlign: 'center',
          }}>
          <ActionBtn
            loading={loading}
            disabled={loading || (formData && !formData.isValid)}
            label={<span>Save Team</span>}
            onClick={editTeam}
            onEnter={editTeam}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

EditTeamDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  editTeam: PropTypes.func,
  team: PropTypes.object,
  onEdit: PropTypes.func,
};

EditTeamDialog.defaultProps = {
  open: false,
  onClose: () => {},
  team: {},
};

export default EditTeamDialog;
